import React from 'react'
import { l } from '@manychat/manyui'

import { goalTypes } from 'apps/aiAutomation/lib/goals'
import { GoalType } from 'shared/api/requests/aiEngagementGoal/schemas'

interface GoalTypeHintProps {
  type: GoalType
}

export const GoalTypeHint = ({ type }: GoalTypeHintProps) => {
  return (
    <div className="m-b-lg p-x-md p-y b-a rounded">
      <p>
        <span className="m-b-xs d-block font-medium">
          {l.getString(goalTypes[type].descriptionTitle)}
        </span>

        <span className="d-block text-body-sm text-secondary">
          {l.getString(goalTypes[type].descriptionText)}
        </span>
      </p>
    </div>
  )
}
